<template>
  
  <div class="upload-component v_upload">

    <section class="upload">

      <input type="file" :accept="allowed[type]" :multiple="multiple"
        @change="emitChange()" ref="input">
      <img :src="icon" />
      <span>Carica file</span>

    </section>

  </div>

</template>

<script>
export default{

  props: {

    multiple: {
      required: false,
      type: Boolean,
      default: false
    },

    type: {
      required: false,
      type: String,
      default: 'all'
    }

  },

  data: function(){
    return {
      icon: window.location.origin + '/media/upload_icon.png',
      allowed: {
        all: ['.jpeg, .jpg, .png, .svg, .gif, .pdf, .docx, .txt, .csv, .xmls'],
        images: ['.jpeg, .jpg, .png, .svg, .gif'],
        documents: ['.pdf, .docx, .txt, .csv, .xmls']
      },
      // dragover: false
    }
  },

  methods: {

    emitChange: function(){

      if( this.multiple ){
        this.$emit('input', this.$refs.input.files);
      } else{
        this.$emit('input', this.$refs.input.files[0]);
      }

    }

  }

}
</script>

<style scoped>
.upload{
  width: 100%;
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 1.5em;
  background-color: var(--background-gray-2);
  border: 1px dashed black;
  color: var(--blue-message);
  transition: all .2s linear;
}
.upload .dragover{
  transform: scale(1.1);
}
.upload img{
  margin-right: 10px;
  height: 1.3em;
  width: auto;
}
.upload input[type="file"]{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  opacity: 0;
  cursor: pointer;
}
</style>
